import "./ProfileDropdown.css";

import { Dropdown, type MenuProps } from "antd";
// import { FaRegUser } from "react-icons/fa";
// import { MdOutlineQuestionMark } from "react-icons/md";
// import { RiSettings4Line } from "react-icons/ri";
import { TbLogout2 } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

import { logout, useAppSelector } from "../../../../../../_store";

export const ProfileDropdown = () => {
  const { user } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  if (!user) return null;

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <div className="user-header__dropdown-header">
          <div className="user-header__dropdown-avatar">{user.fullName[0]}</div>
          <div className="user-header__dropdown-info">
            <p className="user-header__dropdown-name">{user.fullName}</p>
            <p className="user-header__dropdown-email">{user.email}</p>
            <p className="user-header__dropdown-role">Admin</p>
          </div>
        </div>
      ),
      disabled: true,
    },
    {
      type: "divider",
    },
    // {
    //   key: "/profile",
    //   label: "Profile",
    //   icon: <FaRegUser />,
    // },
    // {
    //   key: "/settings",
    //   label: "Settings",
    //   icon: <RiSettings4Line />,
    // },
    // {
    //   key: "/help",
    //   label: "Help",
    //   icon: <MdOutlineQuestionMark />,
    // },
    // {
    //   type: "divider",
    // },
    {
      key: "logout",
      label: "Logout",
      icon: <TbLogout2 />,
    },
  ];

  const handleMenuClick: MenuProps["onClick"] = async ({ key }) => {
    if (key === "logout") {
      await logout(navigate);
    } else {
      navigate(key);
    }
  };

  return (
    <Dropdown
      menu={{ items, onClick: handleMenuClick, className: "profileDropdownUl" }}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <button
        className="user-header__user-btn"
        aria-label="User menu"
        style={{ all: "unset", cursor: "pointer" }}
      >
        <div className="user-header__user-btn" aria-label="User menu">
          <div className="user-header__avatar">{user.fullName[0]}</div>
          <div className="user-header__user-info">
            <span className="user-header__user-name">{user.email}</span>
            <span className="user-header__user-role">Admin</span>
          </div>
        </div>
      </button>
    </Dropdown>
  );
};
